<template>
  <span
    class="role-limit-badge"
    :class="statusClass"
    v-c-tooltip="tooltipContent"
  >
    {{ current }}/{{ limit }}
  </span>
</template>

<script>
export default {
  name: 'RoleLimitBadge',

  props: {
    usage: {
      type: Object,
      required: true,
      // Expected: {limit: number, current: number, available: number}
      validator: (val) => {
        return val && typeof val.limit === 'number' && typeof val.current === 'number'
      }
    }
  },

  computed: {
    limit() {
      return this.usage.limit
    },

    current() {
      return this.usage.current
    },

    available() {
      return this.usage.available ?? (this.limit - this.current)
    },

    percentUsed() {
      if (this.limit === 0) return 100
      return (this.current / this.limit) * 100
    },

    statusClass() {
      if (this.available <= 0) {
        return 'status-full'
      }
      if (this.percentUsed >= 80) {
        return 'status-almost-full'
      }
      return 'status-ok'
    },

    tooltipContent() {
      if (this.available <= 0) {
        return this.$pgettext('collaborators.limits', 'Limit reached - no more slots available')
      }
      if (this.available === 1) {
        return this.$pgettext('collaborators.limits', '1 slot available')
      }
      const msg = this.$pgettext('collaborators.limits', '{count} slots available')
      return msg.replace('{count}', this.available)
    }
  }
}
</script>

<style scoped>
.role-limit-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  white-space: nowrap;
}

.status-ok {
  background-color: #d4edda;
  color: #155724;
}

.status-almost-full {
  background-color: #fff3cd;
  color: #856404;
}

.status-full {
  background-color: #f8d7da;
  color: #721c24;
}
</style>
